import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import * as React from 'react';

var _excluded$1 = ["title", "titleId"];
var CheckCircleFilled24 = function CheckCircleFilled24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    d: "m11 15.56-3.53-3.53 1.06-1.06L11 13.44l4.47-4.47 1.06 1.06L11 15.56zM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"
  }));
};
CheckCircleFilled24.Size = 24;
CheckCircleFilled24.Title = "CheckCircleFilled";

var _excluded = ["title", "titleId"];
var ExclamationCircleFilled24 = function ExclamationCircleFilled24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12C2 6.479 6.477 2 12 2c5.522 0 10 4.478 10 10 0 5.523-4.478 10-10 10-5.523 0-10-4.477-10-10Zm9.01-4.93V14h2V6h-2v.93c0 .009-.002.018-.004.028A.178.178 0 0 0 11 7a.13.13 0 0 0 .005.035.13.13 0 0 1 .005.035Zm2.11 8.35h-2.25v2.25h2.25v-2.25Z",
    clipRule: "evenodd"
  }));
};
ExclamationCircleFilled24.Size = 24;
ExclamationCircleFilled24.Title = "ExclamationCircleFilled";

export { CheckCircleFilled24 as C, ExclamationCircleFilled24 as E };
//# sourceMappingURL=ExclamationCircleFilled24-82b281ac.js.map
